<template>
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
        :loading="false"
        :hasDownload="true"
    >
      <template #subHeaderActions>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <DateRangePicker id="stat-daterangepicker" @update:date="handleRangeDate" />
          <OutlineButton btn-class="btn-sm" icon-class="fas fa-download fs-3" type="primary" btn-text="button.download" @click="downloadView" :isLoading="isLoadingDownload"/>
        </div>
      </template>
      
      <template #layoutContent>
        <CrmGetTotalAppointmentByStatus :load-stats="loadWidgetStatData" :title="$t('menu.crm.appointments') " id="appointments" /> 
        <CrmTopTotalAppointmentPerCreator :load-stats="loadWidgetStatData" :title="$t('appointments.appointment_by_seller') " id="appointment_by_seller" /> 

       
        <div class="card shadow-sm mb-5 card-flush overflow-hidden" v-if="topTotalAppointmentsByContact?.length > 0">
          <div class="card-header">
            <div class="card-title">
              <h5 style="text-align: start">{{ $t('appointments.appointment_by_client') }}</h5>
            </div>
          </div>
          <div class="card-body">
            <div class="row mt-5 overflow-auto flex-nowrap min-w-100" style="white-space: nowrap;">
              <div class="col-12 col-md-6 col-lg-3 mb-4" v-for="(item, index) in topTotalAppointmentsByContact" :key="index">
                <div class="card p-3 h-100 bg-light-primary">
                  <div class="d-flex flex-stack mb-3">
                    <div class="d-flex cursor-pointer symbol">
                      <span class="symbol-label symbol-40px symbol-md-40px fw-bold text-primary img-size rounded-circle me-2" style="width: 20px; height: 20px; background-color: #d1e6f1;">{{initial(item?.contact_name)}}</span><span class="mt-1">{{item?.contact_name}}</span>
                    </div>
                    <span class="text-end badge badge-primary">{{item?.total_appointments}}</span>
                  </div>
                  <div class="d-flex flex-stack">
                    <div class="card px-3 pt-2" v-for="status_count in item?.status_counts">
                      <h6 class="font-weight-900">
                        <span class="me-2" :class="'text-'+filterStatus(status_count.status)?.color">{{status_count.count}}</span>
                        {{filterStatus(status_count.status) ? filterStatus(status_count.status)[locale] : ''}}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </SubLayout>
</template>
<script setup>
  import {onMounted, ref, nextTick, shallowRef, computed, watch} from "vue";
  import {useStore} from "vuex";
  import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
  import i18n from '@/plugins/i18n';
  import DateRangePicker from "@/components/DateRangePicker.vue";
  import { useLocales } from "@/composables/locales";
  import { useInitialName } from "@/composables/InitialName";
  import OutlineButton from "@/components/OutlineButton";
import CrmGetTotalAppointmentByStatus from "@/components/stats/widgets/CrmGetTotalAppointmentByStatus.vue";
import CrmTopTotalAppointmentPerCreator from "@/components/stats/widgets/CrmTopTotalAppointmentPerCreator.vue";

  const {locale} = useLocales()
  const store = useStore()
  const {initial} = useInitialName()
  
  const title = ref("navigation.statistics")
  const breadcrumbs = ref([
    {
      name: 'menu.crm.appointments',
      path: '/admin'
    }
  ])
  
  const query = ref({
    start_date: '',
    end_date: '',
    creator_id: ''
  })
  
  const topTotalAppointmentsByContact = ref([])
  
  const isLoadingDownload = ref(false)
  
  const appointmentStatus = computed(() => store.getters['appointments/appointmentStatus'])


  watch(() => query.value.creator_id, (value) => {
    loadData()
  })

  function handleRangeDate (range) {
    query.value.start_date = range.start_date
    query.value.end_date = range.end_date
    if(query.value.start_date && query.value.end_date) loadData()
  }

  async function loadWidgetStatData(params) {
    try {
      const res = await store.dispatch('statistics/getAppointmentStats', params)
      return res
    } finally {
    }
  }
  
  function loadData(){
    Promise.all([
      store.dispatch('statistics/getAppointmentStats', {startDate: query.value.start_date, endDate: query.value.end_date, creator_id: query.value.creator_id}).then((res) => {
        topTotalAppointmentsByContact.value = res.data?.topTotalAppointmentsByContact
      }),
      store.dispatch('company/generalInformation'),
      store.dispatch('appointments/loadAppointmentStatus'),
    ]).then(() => {
    })
  }

  function downloadView(){
    isLoadingDownload.value = true
    
    store.dispatch('statistics/getDownloadAppointmentStatistics', query.value)
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data], { type: res.headers['content-type'] }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', i18n.global.t('menu.crm.appointments')+query.value.start_date+'.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.toastr['success'](i18n.global.t('notification.download_appointment'))
        })
        .catch(err => {
        }).finally(() => isLoadingDownload.value = false)
  }
  
  onMounted(() => {
    let start = moment().subtract(29, 'days');
    let end = moment();
    query.value.start_date = start.format('DD-MM-YYYY')
    query.value.end_date = end.format('DD-MM-YYYY')
  
    if(query.value.start_date && query.value.end_date){
      nextTick(() => {
        loadData();
      });
    }
  })
  
  function filterStatus(value) {
    let statistic = appointmentStatus.value.find(status => status.value === value);
    return statistic;
  }
  
 
  

</script>
  
<style>
.symbol>img {
    width: 20px;
    height: 20px;
}
</style>